import React from "react";
import { useAuth } from "@/context/AuthContext";

export function UsageMeter({ compact = false }) {
  const { user } = useAuth();
  if (!user) return null;
  const used = user.analyses_used || 0;
  const limit = user.analyses_limit || 0;
  const remaining = user.analyses_remaining ?? Math.max(0, limit - used);
  const pct = limit ? Math.min(100, (used / limit) * 100) : 0;
  const nearLimit = remaining <= 1;

  return (
    <div data-testid="usage-meter" className={compact ? "" : "space-y-1.5"}>
      <div className="flex items-center justify-between text-xs">
        <span className="text-muted-foreground">{used} / {limit} analyses today</span>
        <span className={nearLimit ? "text-primary font-medium" : "text-muted-foreground"}>
          {remaining} left
        </span>
      </div>
      <div className="h-1.5 w-full rounded-full bg-muted overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-700"
          style={{ width: `${pct}%`, backgroundColor: nearLimit ? "hsl(var(--primary))" : "#38BDF8" }}
        />
      </div>
    </div>
  );
}
